import React, { FC, useMemo } from 'react';
import { AnalyticsUserSessionDurationProps } from './AnalyticsUserSessionDurationProps';
import { BarChartPro } from '@mui/x-charts-pro/BarChartPro';
import { formatToTime } from '../AnalyticsPagesTimeSpent/utils';
import AnalyticsLoader from '../AnalyticsLoader';
import { groupDataByMonthAndGetAvg } from './utils';

const AnalyticsUserSessionDuration: FC<AnalyticsUserSessionDurationProps> = ({
  data,
  grouping,
  loading,
}) => {
  const chartData: any = useMemo(() => {
    if (grouping && grouping === 'month') {
      return groupDataByMonthAndGetAvg(data);
    }

    return data;
  }, [data, grouping]);

  return (
    <AnalyticsLoader loading={loading}>
      <BarChartPro
        dataset={chartData}
        xAxis={[
          {
            scaleType: 'band',
            dataKey: 'date',
            tickLabelStyle: { angle: -45 },
          },
        ]}
        yAxis={[
          {
            dataKey: 'number',
            valueFormatter: (value) => formatToTime(value),
          },
        ]}
        series={[
          {
            dataKey: 'number',
            label: 'Avg Duration',
            valueFormatter: (value) => formatToTime(value),
          },
        ]}
        slots={{
          noDataOverlay: () => null,
        }}
      />
    </AnalyticsLoader>
  );
};

export default AnalyticsUserSessionDuration;
